export const DayTypes = {
  'a5c65faa-5d22-44d8-aa89-a9dc32b2a4f0': 'Workout Day',
  '1266b4b5-8a6e-40c4-a5bf-a0a18326de61': 'Rest Day',
  'cc53326c-a630-4320-a14d-de224827210f': 'Refeed Day',
};
